import { FC } from 'react';
import classNames from 'classnames';

import { IMyInvestmentsSecondaryMarket } from 'models';

import { useTranslate } from 'hooks';

import Utils from 'utils/utils';

import s from './index.module.scss';

export const InvestmentSaleStatus: FC<{
	secondaryMarket: IMyInvestmentsSecondaryMarket;
	refunded?: boolean;
}> = ({ secondaryMarket, refunded }) => {
	const { finishedText, soldText, CANCELED } = useTranslate([
		'finishedText',
		'soldText',
		'CANCELED',
	]);

	const isSold = secondaryMarket.sold;
	return (
		<span className={classNames({ [s.red]: isSold })}>
			{isSold
				? `${soldText} ${Utils.moneyFormat(
						secondaryMarket?.soldAmount ? +secondaryMarket.soldAmount : 0,
				  )}`
				: refunded
				? CANCELED
				: finishedText}
		</span>
	);
};
